var App = App || {};

App.Base = (function ($) {
    'use strict';

    function init() {
        HashSupport();
    }

    function HashSupport() {

        const Hash = $(location.hash);

        if (Hash.length == 1) {

            if (Hash.attr("data-bs-toggle") == "collapse") {
                const Target = $(Hash.attr("data-bs-target"));
                const Panel = document.getElementById(Target.attr("id"));
                const Collapse = new bootstrap.Collapse(Panel);
                Collapse.show();
            }

            else if (Hash.attr("data-bs-toggle") == "tab") {
                const Tab = new bootstrap.Tab(Hash);
                Tab.show();
            }

            else if (Hash.hasClass("modal")) {
                const Modal = new bootstrap.Modal(Hash);
                Modal.show();
            }
        }
    }
    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            if (!$(this).hasClass("table-responsive")) {
                $(this).addClass("table");
            }
            if (!$(this).parent().hasClass("table-responsive")) {
                $(this).wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    return {
        init: init,
        RichTextResponsiveTables: RichTextResponsiveTables,
        GetUrlParameter: GetUrlParameter
    };

})(jQuery);

$(function () {
    App.Base.init();
    App.Base.RichTextResponsiveTables($(".rich-text table"));
});